<template>
    <div class="ws-server-list">
        <h2>WS 서버 URL 목록</h2>

        <!-- 메인 서버 URL 섹션 -->
        <div class="main-server">
            <h3>메인 서버</h3>
            <div class="server-card main">
                <div class="url-info">
                    <span class="url">{{ mainServer?.url || '설정된 메인 서버 없음' }}</span>
                    <span class="date">{{ mainServer?.date || '' }}</span>
                </div>
                <div class="actions">
                    <button v-if="mainServer" @click="unsetMainServer" class="danger">메인 해제</button>
                </div>
            </div>
        </div>

        <!-- 서버 URL 목록 섹션 -->
        <div class="server-list">
            <h3>서버 목록</h3>
            <div v-for="server in sortedServers" :key="server.id" class="server-card">
                <div class="url-info">
                    <span class="url">{{ server.url }}</span>
                    <span class="date">{{ formatDate(server.date) }}</span>
                </div>
                <div class="actions">
                    <button v-if="!server.isMain" @click="setAsMain(server)" class="primary">
                        메인으로 설정
                    </button>
                    <button @click="deleteServer(server)" class="danger">삭제</button>
                </div>
            </div>
        </div>

        <!-- 새 서버 추가 폼 -->
        <div class="add-server">
            <input v-model="newServerUrl" placeholder="새 WS 서버 URL 입력" @keyup.enter="addServer">
            <button @click="addServer" class="primary">추가</button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'WsServerUrlList',

    data() {
        return {
            servers: [],
            newServerUrl: '',
        }
    },

    computed: {
        mainServer() {
            return this.servers.find(server => server.isMain)
        },

        sortedServers() {
            return [...this.servers]
                .filter(server => !server.isMain)
                .sort((a, b) => new Date(b.date) - new Date(a.date))
        }
    },

    methods: {
        async fetchServers() {
            try {
                const response = await fetch('/api/ws-servers', {
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                });
                const data = await response.json();
                this.servers = data;
            } catch (error) {
                console.error('서버 목록 가져오기 실패:', error);
            }
        },

        async addServer() {
            if (!this.newServerUrl.trim()) return;

            try {
                const response = await fetch('/api/ws-servers', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    },
                    body: JSON.stringify({
                        url: this.newServerUrl
                    })
                });

                if (response.ok) {
                    await this.fetchServers();
                    this.newServerUrl = '';
                }
            } catch (error) {
                console.error('서버 추가 실패:', error);
            }
        },

        async setAsMain(server) {
            try {
                const response = await fetch(`/api/ws-servers/${server.id}/main`, {
                    method: 'PUT',
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                });

                if (response.ok) {
                    await this.fetchServers();
                }
            } catch (error) {
                console.error('메인 서버 설정 실패:', error);
            }
        },

        async unsetMainServer() {
            try {
                const response = await fetch(`/api/ws-servers/main`, {
                    method: 'DELETE',
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                });

                if (response.ok) {
                    await this.fetchServers();
                }
            } catch (error) {
                console.error('메인 서버 해제 실패:', error);
            }
        },

        async deleteServer(server) {
            if (!confirm('정말 삭제하시겠습니까?')) return;

            try {
                const response = await fetch(`/api/ws-servers/${server.id}`, {
                    method: 'DELETE',
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                });

                if (response.ok) {
                    await this.fetchServers();
                }
            } catch (error) {
                console.error('서버 삭제 실패:', error);
            }
        },

        formatDate(dateString) {
            const date = new Date(dateString);
            return isNaN(date) ? '날짜 없음' : date.toLocaleString();
        }
    },

    mounted() {
        this.fetchServers()
    }
}
</script>

<style scoped>
.ws-server-list {
    padding: 20px;
    max-width: 800px;
    margin: 0 auto;
}

.main-server,
.server-list {
    margin-bottom: 30px;
}

.server-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    margin-bottom: 10px;
    border-radius: 8px;
    background-color: #f5f5f5;
}

.server-card.main {
    background-color: #e3f2fd;
    border: 2px solid #2196f3;
}

.url-info {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.url {
    font-weight: bold;
}

.date {
    font-size: 0.9em;
    color: #666;
}

.actions {
    display: flex;
    gap: 10px;
}

.add-server {
    display: flex;
    gap: 10px;
    margin-top: 20px;
}

input {
    flex: 1;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
}

button {
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

button.primary {
    background-color: #2196f3;
    color: white;
}

button.danger {
    background-color: #f44336;
    color: white;
}

button:hover {
    opacity: 0.9;
}
</style>